module.exports = __webpack_public_path__ + "img/firstBanner.bf408d25.png";